module.exports = __webpack_public_path__ + "static/media/majors-student-professor-university-of-arizona.92888b08.jpg";